import React, { Component } from 'react';

import IconClose from '../icons/icon-close';
import IconArrowUp from '../icons/icon-arrow-up';

export default class DiscussionNotificationsBar extends Component {
    render() {
        if (!this.props.notifications.length) {
            return null;
        }

        return (
            <div className="discussion-bar">
                <div className="discussion-bar-inner" onClick={this.props.onClick}>
                    <IconArrowUp /> {this.props.notifications.length} unread messages
                </div>

                <button className="discussion-bar-close btn btn-small btn-simple-close" onClick={this.props.onClose}>
                    <IconClose />
                </button>
            </div>
        )
    }
}
